// PdfTemplate (PDF designer) action types

export const PDF_TEMPLATE_LIST = "PDF_TEMPLATE_LIST";
export const PDF_TEMPLATE_LIST_SUCCESS = "PDF_TEMPLATE_LIST_SUCCESS";
export const PDF_TEMPLATE_LIST_FAILURE = "PDF_TEMPLATE_LIST_FAILURE";

export const PDF_TEMPLATE_RENDER = "PDF_TEMPLATE_RENDER";
export const PDF_TEMPLATE_RENDER_SUCCESS = "PDF_TEMPLATE_RENDER_SUCCESS";
export const PDF_TEMPLATE_RENDER_FAILURE = "PDF_TEMPLATE_RENDER_FAILURE";

export const PDF_TEMPLATE_SAVE = "PDF_TEMPLATE_SAVE";
export const PDF_TEMPLATE_SAVE_SUCCESS = "PDF_TEMPLATE_SAVE_SUCCESS";
export const PDF_TEMPLATE_SAVE_FAILURE = "PDF_TEMPLATE_SAVE_FAILURE";

export const PDF_TEMPLATE_DELETE = "PDF_TEMPLATE_DELETE";
export const PDF_TEMPLATE_DELETE_SUCCESS = "PDF_TEMPLATE_DELETE_SUCCESS";
export const PDF_TEMPLATE_DELETE_FAILURE = "PDF_TEMPLATE_DELETE_FAILURE";

export const PDF_TEMPLATE_DUPLICATE = "PDF_TEMPLATE_DUPLICATE";
export const PDF_TEMPLATE_DUPLICATE_SUCCESS = "PDF_TEMPLATE_DUPLICATE_SUCCESS";
export const PDF_TEMPLATE_DUPLICATE_FAILURE = "PDF_TEMPLATE_DUPLICATE_FAILURE";

export const PDF_TEMPLATE_UPLOAD_SOURCE = "PDF_TEMPLATE_UPLOAD_SOURCE";
export const PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS =
  "PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS";
export const PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE =
  "PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE";

export const PDF_TEMPLATE_PREVIEW = "PDF_TEMPLATE_PREVIEW";
export const PDF_TEMPLATE_PREVIEW_SUCCESS = "PDF_TEMPLATE_PREVIEW_SUCCESS";
export const PDF_TEMPLATE_PREVIEW_FAILURE = "PDF_TEMPLATE_PREVIEW_FAILURE";
